import { render, staticRenderFns } from "./Dropdown3.vue?vue&type=template&id=2123144b"
import script from "./Dropdown3.vue?vue&type=script&lang=js"
export * from "./Dropdown3.vue?vue&type=script&lang=js"
import style0 from "./Dropdown3.vue?vue&type=style&index=0&id=2123144b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports